import SubtitleStyleControl from 'src/themes/cosmos/components/SubtitleStyleControl';
import useSubtitle from 'src/hooks/useSubtitle';

const SubtitleStyleControlContainer = () => {
  const { subtitleStyle, saveUpdatedSubtitleStyle, setDefaultSubtitleStyle } = useSubtitle();
  return (
    <SubtitleStyleControl
      color={subtitleStyle.color}
      size={subtitleStyle.size}
      stroke={subtitleStyle.stroke}
      background={subtitleStyle.background}
      onBackgroundChange={(background) => {
        saveUpdatedSubtitleStyle({ background });
      }}
      onColorChange={(color) => {
        saveUpdatedSubtitleStyle({ color });
      }}
      onSizeChange={(size) => {
        saveUpdatedSubtitleStyle({ size });
      }}
      onStrokeChange={(stroke) => {
        saveUpdatedSubtitleStyle({ stroke });
      }}
      onSetDefaultStyle={setDefaultSubtitleStyle}
    />
  );
};

export default SubtitleStyleControlContainer;
